import React from 'react';
import PropTypes from 'prop-types';
import { useOutletContext } from 'react-router-dom-v5-compat';

import { getTypeName } from '~/platform/shared/claims-appeals';
import Issues from '../components/appeals-v2/Issues';
import { addStatusToIssues } from '../utils/appeals-v2-helpers';

export default function AppealsV2DetailPage({ appeal: propAppeal }) {
  // Flag off: rendered as an Outlet child (appeal from context). Flag on: a
  // va-tabs panel with `appeal` passed as a prop.
  const [ctxAppeal] = useOutletContext() || [];
  const appeal = propAppeal ?? ctxAppeal;
  const issues = addStatusToIssues(appeal.attributes.issues);
  const appealType = getTypeName(appeal);

  return (
    <div id="tabPanelv2detail">
      <Issues issues={issues} appealType={appealType} />
    </div>
  );
}

AppealsV2DetailPage.propTypes = {
  appeal: PropTypes.shape({
    type: PropTypes.string,
    attributes: PropTypes.object.isRequired,
  }),
};
